import { eventBus, getHost, getBody } from '../../foundation';
import { IJson, IJsonScenario, IMutableWidgetsMap, Routes, TWAction } from '@libs/types';
import { ArrayQueue, ExponentialBackoff, Websocket, WebsocketBuilder } from 'websocket-ts';

class WebsoketService {
    private consoleColor = 'background: #222; color: #a2e297';
    private ws: Websocket | undefined;
    private handshaked = false;
    private heartbeatInterval: NodeJS.Timeout | undefined;

    subscribeWidget = async (action: TWAction, currentPageId: string, mutableWidgetsMap: IMutableWidgetsMap<unknown, unknown>) => {
        this.log(`Try to subscribe!`);
        this.openConnection();
        if (!this.handshaked) {
            await this.handshake();
        }
        this.ws?.send(JSON.stringify(await getBody(action, currentPageId, mutableWidgetsMap)));
    };

    private openConnection() {
        if (!this.ws) {
            this.log('Start Opening connection');
            // documentation https://jjxxs.github.io/websocket-ts/
            this.ws = new WebsocketBuilder(`${getHost()}${Routes.WS_SOCKET}`)
                .withBuffer(new ArrayQueue())
                .withBackoff(new ExponentialBackoff(1000, 5)) // 1s, 2s, 4s, 8s, 16s, 32s, 64s
                .onOpen(() => this.startHeartbeat())
                .onClose(() => this.stopHeartbeat())
                .withMaxRetries(5)
                .onReconnect(async () => {
                    this.log('WS start reconnection....');
                    await this.handshake();
                })
                .onMessage((i, ev) => this.echoOnMessage(i, ev))
                .build();
        }
    }

    private startHeartbeat() {
        this.heartbeatInterval = setInterval(() => {
            this.ws?.send('heartbeat');
        }, 5000); // Send heartbeat every 5 seconds
    }

    private stopHeartbeat() {
        clearInterval(this.heartbeatInterval);
    }

    private async handshake() {
        this.log('Put in pull handshake message');
        this.handshaked = false;
        this.ws?.send(JSON.stringify(await getBody()));
        this.handshaked = true;
    }

    private echoOnMessage(_i: Websocket, ev: MessageEvent<string>) {
        const data = ev?.data;
        if (data === 'pong') return;
        if (process.env.NX_PUBLIC_WS_LOG_EVENTS) this.log(`received message: ${data}`);

        const json = JSON.parse(ev?.data ?? {}) as IJson;
        const widgets = json?.scenario?.pages?.[0]?.widgets ? json?.scenario?.pages?.[0]?.widgets : (json as unknown as IJsonScenario)?.pages?.[0]?.widgets;
        widgets?.forEach((w) => {
            eventBus.emitWsMessage(w);
        });
    }

    private log(message: string) {
        if (process.env.NX_PUBLIC_WS_LOG_EVENTS) {
            console.log(`%c WS: ${message}`, this.consoleColor);
        }
    }

    // Add event listeners
    // ws.addEventListener(WebsocketEvent.open, () => console.log('opened!'));
    // ws.addEventListener(WebsocketEvent.close, () => console.log('closed!'));
    // ws.addEventListener(WebsocketEvent.message, echoOnMessage);
}

const websoketService = new WebsoketService();

export { websoketService };
